import { useToast } from '@quadminds/mindkit';
import { IAuthMeV2OutputDto, IUserOutputDto } from '@quadminds/shared/auth-system';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

interface UpdateUserParams {
    userId: string;
    payload: Partial<IUserOutputDto>;
}

export const useUpdateUser = () => {
    const queryClient = useQueryClient();
    const { toast } = useToast();

    return useMutation({
        mutationFn: async ({ userId, payload }: UpdateUserParams) => {
            return usersApi.updateUser(userId, payload);
        },
        onMutate: async ({ userId: _userId }) => {
            await queryClient.cancelQueries({ queryKey: ['userInfo'] });
            const previousUserInfo = queryClient.getQueryData<IAuthMeV2OutputDto>(['userInfo']);

            return { previousUserInfo };
        },
        onError: (error, _variables) => {
            toast({
                title: 'Error',
                description: 'Failed to save your language preference. Please try again.',
                variant: 'destructive',
            });
            console.error('Error updating user:', error);
        },
        onSuccess: () => {
            localStorage.removeItem('i18nextLng');
        },

        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['userInfo'] });
        },
    });
};
